export enum AwEventType {
  GateClicked = "gate_clicked",
  GateSubmitted = "gate_submitted",
  MomentPlayed = "moment_played",
  WebinarPlayed = "webinar_played",
  WebinarViewed = "webinar_viewed",
  MomentShared = "moment_shared",
  WebinarShared = "webinar_shared",
  MomentPlaying = "moment_playing"
}
